"use client";

import React from "react";
import { Phone, Mail, Loader2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Separator } from "@/components/ui/separator";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 text-center bg-white/5 rounded-2xl border border-white/10 animate-in fade-in zoom-in duration-500">
        <h3 className="text-2xl font-semibold text-primary mb-2">Message Sent!</h3>
        <p className="text-neutral-300 mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-xl">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="name" rules={{
      required: "Name is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-neutral-200">Your Name</FormLabel>
            <FormControl>
              <Input placeholder="John Doe" {...field} className="bg-white text-neutral-900 border-none rounded-xl shadow-inner placeholder:text-neutral-400 focus-visible:ring-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-neutral-200">Email Address</FormLabel>
            <FormControl>
              <Input type="email" placeholder="john@example.com" {...field} className="bg-white text-neutral-900 border-none rounded-xl shadow-inner placeholder:text-neutral-400 focus-visible:ring-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-neutral-200">Phone Number</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+1 555‑123‑4567" {...field} className="bg-white text-neutral-900 border-none rounded-xl shadow-inner placeholder:text-neutral-400 focus-visible:ring-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="subject" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-neutral-200">Subject</FormLabel>
            <FormControl>
              <Input placeholder="Brief subject" {...field} className="bg-white text-neutral-900 border-none rounded-xl shadow-inner placeholder:text-neutral-400 focus-visible:ring-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-neutral-200">Message</FormLabel>
            <FormControl>
              <Textarea placeholder="How can we help you?" {...field} className="bg-white text-neutral-900 border-none rounded-xl shadow-inner placeholder:text-neutral-400 min-h-[120px] focus-visible:ring-primary" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-xl text-red-400 text-sm">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold py-6 text-lg rounded-xl shadow-lg transition-all duration-300">
        {isSubmitting ? <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Sending...
          </> : "Send Message"}
      </Button>
    </Form>;
}
export default function GetInTouchForm() {
  return;
}